export enum BreadCrumbCategoryEnum{
  AccountSettings = 'ACCOUNT_SETTINGS',
  AddressDawa = 'ADDRESS_DAWA',
  AppointmentOverview = 'APPOINTMENT_OVERVIEW',
  EventActionDialog = 'EVENT_ACTION_DIALOG',
  FileUpload = 'FILE_UPLOAD',
  FitterHour = 'FITTER_HOUR',
  HourRegistrationOverview = 'HOUR_REGISTRATION_OVERVIEW',
  LoginHelpers = 'LOGIN_HELPERS',
  MFA = 'MFA',
  UserMessages = 'USER_MESSAGES',
  Request = 'REQUEST',
  SiteConfiguration = 'SITE_CONFIGURATION',
  Token = 'TOKEN',
  UserConfiguration = 'USER_CONFIGURATION',
  WorksheetOverview = 'WORKSHEET_OVERVIEW',
  Calendar = 'CALENDAR',
  QA = 'QA',
  PushNotifications = 'PUSH_NOTIFICATIONS',
  Materials = 'MATERIALS'
}

export enum HomepageElement{
  HourRegistrationOverview = 'hourRegistrationOverview',
  WorksheetActiveTimer = 'worksheetActiveTimer',
  NextCalendarEvent = 'nextCalendarEvent',
  NextWorksheet = 'nextWorksheet',
  OverdueWorksheet = 'overdueWorksheet'
}
  
export enum ThemeSetting {
  system = 'system',
  light = 'light',
  dark = 'dark',
  darkHighContrast = 'darkHighContrast'
}
  
export enum StartTabSetting {
  mine = 'mine',
  shared = 'shared',
  responsibleFor = 'responsibleFor',
  done = 'done',
  all = 'all'
}
  
export enum MaterialStartTabSetting {
  all = 'all',
  wholesalerCatalog = 'wholesalerCatalog',
  favorites = 'favorite',
  locations = 'locations',
  ownItems = 'ownItems'
}
  
export enum MapSetting {
  google = 'google',
  apple = 'apple'
}